import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_2 = { class: "loading-container" }
const _hoisted_3 = { class: "loading-text" }

import { ref, watch } from 'vue';

interface Props {
  isVisible: boolean;
  text?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LodingComponent',
  props: {
    isVisible: { type: Boolean },
    text: { default: '로딩 중...' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (__props.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"loading-spinner\" data-v-27f6d33a><div class=\"spinner-ring\" data-v-27f6d33a></div><div class=\"spinner-ring\" data-v-27f6d33a></div><div class=\"spinner-ring\" data-v-27f6d33a></div><div class=\"spinner-ring\" data-v-27f6d33a></div></div>", 1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.text), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})